const { InnerBlocks } = wp.blockEditor;

import Inspector from './inspector';

const Edit = ({ attributes, setAttributes }) => {
  const { scrollable, size, vAlign, hAlign, margin } = attributes;

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <div className={`grid-sumicity ${margin}`}>
        <div
          className={`grid-sumicity-content wp-editor size-${size} ${vAlign} ${hAlign} ${
            scrollable && 'scrollable'
          }`}
        >
          <InnerBlocks />
        </div>
      </div>
    </>
  );
};

export default Edit;
